import React from "react";
import { withTheme } from "../../../hoc";
import { DocumentBreadCrumbStyle, DocumentSection, ButtonArea } from "./style";
import { DividerIcon } from "../../../assets/images/svgs";
import Button from "../Button";
import { ButtonState } from "../Button/types/buttonState";

const DocumentBreadCrumb = ({
  handleAccept,
  handleDecline,
  acceptanceStatus,
  loading,
  data,
  ...props
}) => {
  return (
    <DocumentBreadCrumbStyle {...props}>
      <div>
        <DocumentSection>
          {props.children}
          <div className="logo-wrapper">
            <img src={props.imgSrc} alt={props.label} />
            <h2>{props.label}</h2>
          </div>
          <div>
            <p>
              Name:{" "}
              <span>
                {data?.actionPerformedBy?.username ||
                  data?.actionPerformedBy?.fullName}
              </span>
            </p>{" "}
            <DividerIcon style={{ margin: "0 12px" }} />
            <p>
              Email: <span>{data?.actionPerformedBy?.emailAddress}</span>
            </p>{" "}
            <DividerIcon style={{ margin: "0 12px" }} />
            <p>
              MatricNumber: <span>{data?.actionPerformedBy?.matricNumber}</span>
            </p>
          </div>
        </DocumentSection>
      </div>
      <div>
        {acceptanceStatus === false && (
          <ButtonArea>
            <Button
              variant={ButtonState.PRIMARY}
              padding="5px 23px"
              onClick={handleAccept}
              disabled={loading}
            >
              Accept
            </Button>
          </ButtonArea>
        )}
        {acceptanceStatus && (
          <ButtonArea>
            <Button
              variant={ButtonState.TERTIARY}
              padding="5px 23px"
              onClick={handleDecline}
              disabled={loading}
            >
              Decline
            </Button>
          </ButtonArea>
        )}
      </div>
    </DocumentBreadCrumbStyle>
  );
};

export default withTheme(DocumentBreadCrumb);
